// Internal Imports
import store from "../../store";

// Service Imports
import {
  getColVisibilityList,
  getRbacRoles,
  updateColVisibilityList,
  fetchPricingInfo,
  getAllMeteredUsage,
  getDocCtaEventsService,
  getDigitalTransationEventsService,
} from "./commonService";

// Method Imports
import { parseColVisiblity, generateMeteringUsage } from "./commonMethods";

// Functions
export const getColVisibility = page => async () => {
  try {
    const rbacRoles = await getRbacRoles();
    const colVisibilityList = await getColVisibilityList(page);

    return Promise.all([rbacRoles, colVisibilityList])
      .then(response => parseColVisiblity(response, page))
      .catch(error => {
        console.debug("commonActions =>", error);
        throw error;
      });
  } catch (error) {
    throw error;
  }
};

export const updateColVisibility = (obj, page) => async dispatch => {
  try {
    const updateList = await updateColVisibilityList(obj, page);

    // Pick the first object data
    const payload =
      updateList.Visibility[Object.keys(updateList.Visibility)[0]];

    // Update all the columns visibility key
    let storeLocation = "";
    // page === "Pricelist" ? "PricebookStore" : "ProductsStore";
    if (page === "Pricelist") {
      storeLocation = "PricebookStore";
    } else if (page === "DealTable") {
      storeLocation = "DealTableStore";
    } else {
      storeLocation = "ProductsStore";
    }
    const reduxState = store.getState();
    const { columnDefs } = reduxState[storeLocation];
    const { dealTableId } = reduxState.QuotationStore;
    let updatedColDefs = "";
    if (storeLocation === "DealTableStore") {
      updatedColDefs = columnDefs[dealTableId].map(({ ...col }) => {
        if (col.hide !== undefined) {
          col.hide = !payload[col.columnId];
        }
        return col;
      });
    } else {
      updatedColDefs = columnDefs.map(({ ...col }) => {
        if (col.hide !== undefined) {
          col.hide = !payload[col.columnId];
        }
        return col;
      });
    }

    dispatch({
      type: "REACTION_MANAGE_COLUMN",
      payload: updatedColDefs,
    });

    return updateList;
  } catch (error) {
    throw error;
  }
};

export const fetchPricingInfoAction = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchPricingInfo()
      .then(res => {
        dispatch({
          type: "FETCH_PRICING_INFO",
          payload: res,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

//! TEMP ACTION TO FETCH DOC CTA BTNS USAGE, REMOVE ONCE THESE EVETNS ARE ADDED TO METERING API
export const getDocCtaUsageEvents =
  ({ docId, isFreePlan = true }) =>
  async dispatch => {
    try {
      const metering = await getAllMeteredUsage();
      const events = await getDocCtaEventsService({
        eventNames:
          "document_downloaded,send_for_acceptance,send_to_someone,generated_magiclink,generated_snaplink,generated_masterlink,digital_transactions",
        isFreePlan,
      });
      const digital = await getDigitalTransationEventsService({
        docId,
        isFreePlan,
      });

      return Promise.all([metering, events, digital]).then(response => {
        const payload = generateMeteringUsage(response);
        dispatch({
          type: "UPDATE_METERING_VALUES",
          payload,
        });
      });
    } catch (error) {
      throw error;
    }
  };
